import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  Grid,
  Button,
  Paper,
  Typography,
  FormLabel,
  Tooltip,
  Backdrop,
} from "@mui/material";
import Note from "../../../AdminSettings/Images/alert.png";
import { createStyles, makeStyles } from "@mui/styles";

import Popup from "../../../Base/views/Popup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useDispatch, useSelector } from "react-redux";
import { UpdateOfferLetterIDAction } from "../../../../../store/ATS/OfferLetterID/Action";

const OfferLetterIDConfiguration = () => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          theme.palette.mode === "dark"
            ? "rgb(0 0 0 / 20%) 0px 0px 2px 0px, rgb(0 0 0 / 12%) 0px 12px 24px -4px"
            : "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "20px",
        borderRadius: "10px",
        backgroundColor: "#f3edfd",
      },
      previewBox: {
        backgroundColor: "#ffffff",
        padding: "15px",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
      },
      Backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: "rgba(255, 255, 255, 0.5)",
        position: "absolute", 
        borderRadius: "inherit", 
      },
    }),
  );

  const classes = useStyles();
  const dispatch = useDispatch();
  const initialValue = {
    prefix: "",
    suffix: "",
  };

  const [inputData, setInputData] = useState(initialValue);
  const [updateshow, setUpdateShow] = useState(false);
  const { offer_letter_id_data, isLoading } = useSelector(
    (state) => state.AtsReducer?.AtsOfferLetterIdReducer || {},
  );

  useEffect(() => {
    if (offer_letter_id_data) {
      setInputData(offer_letter_id_data);
    }
  }, [offer_letter_id_data]);

  const generateSampleOutput = () => {
    let output = "";
    if (inputData?.prefix) {
      output += inputData.prefix;
    }
    output += "00001";

    if (inputData?.suffix) {
      output += inputData.suffix;
    }

    return output;
  };

  const handleInput = (event) => {
    const { name, value } = event?.target || {};

    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleValidate = () => {
    setUpdateShow(true);
  };

  const handleUpdate = async () => {
    setUpdateShow(false);
    dispatch(UpdateOfferLetterIDAction({ ...inputData }));
  };

  return (
    <Box>
      <Popup
        maxWidth="xs"
        openPopup={updateshow}
        setOpenPopup={setUpdateShow}
        title="Note!"
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ mt: 1, mb: 1, textAlign: "center !important" }}>
            <img src={Note} width={"25%"} alt="note_img" />
          </Box>
          <FormControl>
            <FormLabel id="gender-label">
              <Typography variant="h5">
                The new Offer Letter IDs will be generated in the new format.
              </Typography>
            </FormLabel>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingTop: "10px",
          }}
        >
          <Button
            onClick={() => setUpdateShow(false)}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdate}
            variant="contained"
            type="submit"
            className="mpl-primary-btn profile-btn"
            size="small"
            sx={{ margin: "10px" }}
          >
            Ok
          </Button>
        </Box>
      </Popup>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper className={classes.Paper} sx={{ borderRadius: "16px" }}>
            <Backdrop
              className={classes.Backdrop}
              open={isLoading}
            ></Backdrop>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                justifyContent: "space-between",
                mb: 2
              }}
            >
              <Typography
                variant="subtitle1"
                color="inherit"
                sx={{
                  fontWeight: 600,
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  gap: 0.5,
                }}
              >
                Offer Letter ID
                <Tooltip
                  title={"Used to configure the Offer Letter ID format."}
                  arrow
                  placement="top"
                >
                  <InfoOutlinedIcon
                    color="action"
                    sx={{
                      cursor: "pointer",
                      fontSize: 16,
                    }}
                  />
                </Tooltip>
              </Typography>

              <Box>
                <Button
                  type="submit"
                  variant="contained"
                  size="medium"
                  onClick={handleValidate}
                  className="mpl-primary-btn"
                  sx={{ minWidth: "80px" }}
                >
                  Update
                </Button>
              </Box>
            </Grid>

            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="text"
                  label="Prefix"
                  fullWidth
                  name="prefix"
                  onChange={handleInput}
                  value={inputData?.prefix || ""}
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  type="text"
                  label="Suffix"
                  fullWidth
                  name="suffix"
                  onChange={handleInput}
                  value={inputData?.suffix || ""}
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box
                  className={classes.previewBox}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    height: "38px",
                    flex: 1,
                  }}
                >
                  <Typography variant="subtitle2" sx={{ color: "#666", mr: 1 }}>
                    Sample:
                  </Typography>

                  <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                    {generateSampleOutput()}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OfferLetterIDConfiguration;
